import { ref, computed } from 'vue'
import { defineStore } from 'pinia'
import { getUserSync } from '@/services'

export const useUserStore = defineStore('user', () => {
  const id = ref()
  const telegramId = ref(0)
  const firstName = ref('')
  const lastName = ref('')
  const username = ref('')
  const isBot = ref(false)
  const role = ref('')
  const referenceCode = ref('')
  const languageCode = ref('')
  const photoUrl = ref('')
  const addedToAttachmentMenu = ref(false)
  const allowsWriteToPm = ref(false)
  const exchangeId = ref('')

  const detail = computed(() => ({
    id: id.value,
    telegramId: telegramId.value,
    firstName: firstName.value,
    lastName: lastName.value,
    username: username.value,
    isBot: isBot.value,
    languageCode: languageCode.value,
    photoUrl: photoUrl.value,
    addedToAttachmentMenu: addedToAttachmentMenu.value,
    allowsWriteToPm: allowsWriteToPm.value,
    role: role.value,
    referenceCode: referenceCode.value
  }))

  function setUser(userDetail) {
    console.log('SET USER DETAIL: ', userDetail)
    // TODO :: add loop
    id.value = userDetail.id
    telegramId.value = userDetail.telegram_id
    firstName.value = userDetail.first_name
    lastName.value = userDetail.last_name
    username.value = userDetail.username
    isBot.value = userDetail.is_bot
    languageCode.value = userDetail.language_code
    photoUrl.value = userDetail.phote_url
    addedToAttachmentMenu.value = userDetail.added_to_attachment_menu
    allowsWriteToPm.value = userDetail.allows_write_to_pm
    role.value = userDetail.role
    referenceCode.value = userDetail.referal_code
  }

  const getName = () => `${firstName.value} ${lastName.value}`

  return {
    id,
    telegramId,
    firstName,
    lastName,
    username,
    isBot,
    languageCode,
    photoUrl,
    addedToAttachmentMenu,
    allowsWriteToPm,
    role,
    referenceCode,
    detail,
    exchangeId,
    setUser,
    getName,
  }
})
